module.exports = "./img/6a2642227ea79835a0f7d51eb970b3ef.jpg";